import { Button } from '@design';
import { ModalTypes, useModal } from '@terminal/hooks/use-modal/useModal';
import { FiltersPanel } from '@terminal/views/screener/filters-panel/FiltersPanel';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { AssistantConditions } from '../assistant-conditions/AssistantConditions';
import { ConditionsFilters } from '../conditions-filters/ConditionsFilters';
import styles from './ScenarioFilters.module.scss';

export interface ScenarioFiltersProps {
  filtersChildren?: ReactNode;
  onEditAssistantCondition?: (filterKey: string) => void;
  resetAskedQuestions(): void;
}

export const ScenarioFilters = ({
  filtersChildren,
  onEditAssistantCondition,
  resetAskedQuestions,
}: ScenarioFiltersProps) => {
  const { t } = useTranslation('scenario');
  const { open } = useModal(ModalTypes.AddCondition);

  const onAddAnotherCondition = () => {
    open();
    resetAskedQuestions();
  };

  return (
    <FiltersPanel
      title={t('scenario:scenarioConditions')}
      data-testid="scenario-filters"
    >
      <div className={styles.headerWrapper}>
        <div className={styles.filtersWrapper}>
          <ConditionsFilters />
          <AssistantConditions
            onEditAssistantCondition={onEditAssistantCondition}
          />

          <Button
            className={styles.dashedButton}
            data-testid="add-another-condition-btn"
            size="small"
            variant="secondary"
            label={t('scenario:filters.addAnotherCondition')}
            iconPosition="right"
            iconName="Alfred"
            onClick={onAddAnotherCondition}
          />
        </div>

        {filtersChildren}
      </div>
    </FiltersPanel>
  );
};
